import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import useLicensedProductsQueryForGlobalAppShortcutsQuery from './hooks/__generated__/useLicensedProductsQueryForGlobalAppShortcutsQuery.graphql.ts';
import type {
	useLicensedProductsQueryForGlobalAppShortcutsQuery$data,
	useLicensedProductsQueryForGlobalAppShortcutsQuery$variables,
} from './hooks/__generated__/useLicensedProductsQueryForGlobalAppShortcutsQuery.graphql.ts';
import type { GraphQLError } from 'graphql';

export async function preloadGlobalAppShortcutsLicensedProducts(): Promise<{
	data: useLicensedProductsQueryForGlobalAppShortcutsQuery$data | null;
	errors?: ReadonlyArray<GraphQLError>;
	hasErrors: boolean;
}> {
	return query<
		useLicensedProductsQueryForGlobalAppShortcutsQuery$data,
		useLicensedProductsQueryForGlobalAppShortcutsQuery$variables
	>({
		query: useLicensedProductsQueryForGlobalAppShortcutsQuery,
	});
}
